var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.componentName,{tag:"component",attrs:{"index":_vm.index},on:{"close":_vm.close,"add":_vm.add,"change":_vm.change},model:{value:(_vm.Modal),callback:function ($$v) {_vm.Modal=$$v},expression:"Modal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }